import Raven from 'raven-js';
import http from 'hub-http/clients/apiClient';
import { createRpcClientV2, unhandledEnumCase } from 'rpc-client-utils';

import {
  evaluateInAppV2Rpc,
  InAppEvaluationRequest,
} from '../../__generated__/chirp/com/hubspot/purchase/motions/rpc/PurchaseMotionsEvaluationService';
import { PurchaseMotion } from '../types/PurchaseMotion';

const rpcClient = createRpcClientV2({
  hubHttpClient: http,
});

export const fetchPurchaseMotions = async ({
  location,
  apiName,
}: {
  location: NonNullable<InAppEvaluationRequest['locations']>[number];
  apiName: NonNullable<InAppEvaluationRequest['productApiNames']>[number];
}): Promise<Exclude<PurchaseMotion, unhandledEnumCase>[]> => {
  try {
    const response = await rpcClient.call(evaluateInAppV2Rpc, {
      request: {
        locations: [location],
        productApiNames: [apiName],
      },
    });
    return (
      response.purchaseMotionsMapping.productsByLocationString[
        location
      ]?.purchaseMotionsByProductApiName[apiName]?.purchaseMotions.filter(
        isPurchaseMotion
      ) || []
    );
  } catch (e) {
    Raven.captureException(e instanceof Error ? e : new Error(String(e)));
    throw e;
  }
};

function isPurchaseMotion(
  value: unknown
): value is Exclude<PurchaseMotion, unhandledEnumCase> {
  return typeof value === 'string';
}
